module.exports = __webpack_public_path__ + "static/1-3a231a10c0732c6b276948fdeba2feff.png";